const textVariants = {
    error: {
        color: 'secondary',
        fontSize: [0],
    },
};

export default textVariants;
